import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '908258408929715';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.documentElement;
    target.appendChild(script);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-156">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-157" />
    </noscript>;
}